<ws-button [matMenuTriggerFor]="menu" [styleClass]="styleClass" [matIcon]="icon"></ws-button>
<mat-menu #menu="matMenu">
	<ng-container *ngFor="let action of menuActions">
		<button mat-menu-item (click)="action.action()" [disabled]="!!action.disabled">
			<mat-icon *ngIf="action.icon">{{ action.icon }}</mat-icon>
			<span>{{ action.label | translate }}</span>
		</button>
	</ng-container>
</mat-menu>
